import { MatDateFormats } from '@angular/material/core';
import { CopoDateFormats } from '@copo/mat-datepicker-new';
import { Injectable } from '@angular/core';

import { getFormatDate, getParseDate } from './resolved-format-date';

const defaultFormat = 'date';

@Injectable({ providedIn: 'root' })
export class DateFormats implements MatDateFormats, CopoDateFormats {
	parse = {
		dateInput: getParseDate(defaultFormat)
	};

	display = {
		dateInput: getFormatDate(defaultFormat),
		monthYearLabel: 'MMM YYYY',
		dateA11yLabel: 'LL',
		monthYearA11yLabel: 'MMMM YYYY',
		copoShortISOWeekLabel: '[W]W',
		copoISOWeekYearLabel: '[W]WW/GGGG'
	};

	private _format = defaultFormat;

	get format() {
		return this._format;
	}

	set format(value: string) {
		this._format = value;
		this.parse.dateInput = getParseDate(value);
		this.display.dateInput = getFormatDate(value);
	}
}
